import React, { useEffect, useRef } from 'react';

// import Iframe from 'components/Iframe';

function SearchWidget({ windowWidth }) {
    // useEffect(() => {
    //     const script = document.createElement('script');
    //     script.src = 'https://www.ittour.com.ua/tour_search.jsx?id=154701DG73254524516M8&ver=3';
    //     script.id = 'itTourWidgetScriptJsx';
    //     document.body.appendChild(script);
    // }, []);

    // return <div id="itTourWidgetWrapper"></div>;

    const isLoaded = useRef(false);

    const loadScript = (src) => {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = false;
            script.onload = resolve;
            script.onerror = reject;

            const container = document.querySelector('.search-tour-container');
            container.appendChild(script);
        });
    };

    useEffect(() => {
        if (isLoaded.current) return;
        isLoaded.current = true;

        window.osGeo = 115;
        window.osDefaultDeparture = 1831;
        window.osDefaultDuration = '';
        window.osDateFrom = '';
        window.osDateTo = '';
        window.osHotelCategory = '';
        window.osFood = '';
        window.osTransport = '';
        window.osTarget = '/uk/tours/search';
        window.osTargetBlank = true;
        window.osContainer = null;
        window.osTourContainer = null;
        window.osLang = 'ua';
        window.osTourTargetBlank = false;
        window.osOrderUrl = null;
        window.osCurrency = 'converted';
        window.osAutoStart = false;

        const styles = [
            'https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700&subset=cyrillic',
            'https://export.otpusk.com/os/onsite/form.css',
            'https://export.otpusk.com/os/onsite/result.css',
            'https://export.otpusk.com/os/onsite/tour.css',
        ];
        styles.forEach(href => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            document.head.appendChild(link);
        });

        const customStyles = `
        .new_f-ext-container .ui-slider-range,
        .new_f-ext-container .slider-container .ui-widget-content,
        .new_f-container {
            background: rgb(208,67,50) !important;
            background: -moz-linear-gradient(left, rgba(208,67,50,1) 0%, rgba(224,67,50,1) 50%, rgba(127,67,50,1) 100%) !important;
            background: -webkit-gradient(linear, left top, right top, color-stop(0%,rgba(208,67,50,1)), color-stop(50%,rgba(224,67,50,1)), 
                color-stop(100%,rgba(127,67,50,1))) !important;
            background: -webkit-linear-gradient(left, rgba(208,67,50,1) 0%,rgba(224,67,50,1) 50%,rgba(127,67,50,1) 100%) !important;
            background: -o-linear-gradient(left, rgba(208,67,50,1) 0%,rgba(224,67,50,1) 50%,rgba(127,67,50,1) 100%) !important;
            background: -ms-linear-gradient(left, rgba(208,67,50,1) 0%,rgba(224,67,50,1) 50%,rgba(127,67,50,1) 100%) !important;
            background: linear-gradient(to right, rgba(208,67,50,1) 0%,rgba(224,67,50,1) 50%,rgba(127,67,50,1) 100%) !important;
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#d04332', endColorstr='#7f4332',GradientType=1 ) !important;
        }

        .new_progressbar .new_progress-container .new_progress-item {
            background-color: #d04332;
            background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0, #d04332), color-stop(1, #d04332));
            background-image: -moz-linear-gradient(center bottom, #d04332 37%, #d04332 69%);
        }

        .new_spinner-logos-wrap .new_logo-loading-bl svg path {
            fill: #edf2f7 !important;
        }
        .new_spinner-logos-wrap .new_logo-loading-bl svg g path {
            fill: #d04332 !important;
        }

        .new_not-found-message .os-order-form-submit_button:hover,
        .new_f-form .new_f-form-submit:hover,
        .new_f-container .new_f-dropdown-btn-apply:hover,
        .new_t-order-form-open .os-order-form-submit .os-order-form-submit_button:hover,
        .new_t-order-btn:hover {
            cursor: pointer !important;
            background-color: #d04332 !important;
        }

        [class*='new_f-'] input[type="radio"]:checked + ::before,
        .new_f-ext-col-recommend input[type="checkbox"]:checked + ::before {
            border-color: #7f4332 !important;
            background: #d04332 !important;
        }

        .new_f-ext-clear-btn,
        .new_r-filters-reset {
            text-decoration: underline !important;
        }

        .new_t-container,
        .new_t-header-geo.new_t-geo-with-map,
        .new_t-tour-tab-col .new_t-change-btn,
        .new_t-modal-room-title,
        .new_t-menu-back-link,
        .new_r-item-hotel,
        .new_r-item .new_r-item-geo span,
        .new_f-ext-clear-btn,
        .new_r-filters-reset,
        .new_f-ext-bl-title,
        .new_f-label-name {
            color: #222 !important;
        }

        .new_t-tour-tab-col-2 .new_t-important,
        .new_t-order-price, .new_t-date_link,
        .new_t-date_link *,
        .new_r-filter-value,
        .new_r-show-more-results {
            color: #e04332 !important;
        }

        .new_t-menu-item, .new_t-menu-item.selected::after {
            color: #222 !important;
            border-color: #4a5568 transparent transparent transparent !important;
        }

        .new_t-menu-item.selected, .new_t-menu-wrap::after {
            color: #fff !important;
            background-color: #4a5568 !important;
        }

        .new_t-header-geo.new_t-geo-with-map::after,
        .new_r-item .new_r-item-geo span::after {
            background: #222 !important;
        }

        .new_r-item-geo svg,
        .new_t-header-geo svg,
        .new_t-change-btn svg,
        .new_t-tour-tab-col-1 svg,
        .new_r-item-icon {
            fill: #9e9e9e !important;
        }

        .new_f-dropdown-btn .cnt {
            background: none !important;
        }

        .new_f-search-dates-wrap svg,
        .new_f-dropdown-btn .cnt::after,
        .new_f-dropdown-btn::after {
            fill: #e04332 !important;
            border-color: #e04332 transparent transparent !important;
        }

        .new_r-currency-switch label input:checked + span,
        .new_t-tab-content-top,
        .new_t-modal-body-top,
        .new_f-dropdown-body-top,
        .new_t-order-btn, .new_t-order-btn-book,
        .new_t-change-people .new_f-dropdown-btn-apply,
        .new_f-children-age-item:hover,
        .new_f-people-item:hover,
        .new_f-children-list-item,
        .new_f-people-item.active,
        .food .new_t-modal-table .new_t-room-price.selected,
        .new_t-order-form-open .os-order-form-submit .os-order-form-submit_button,
        .new_map-infowindow-price .new_order-button,
        .new_r-item .new_r-item-price,
        .new_r-item:hover .new_r-item-price,
        .new_not-found-message .os-order-form-submit_button,
        .new_f-ext-container .new_f-dropdown-btn-apply,
        .new_f-form .new_f-form-submit,
        #ctyList .new_f-dropdown-btn-apply {
            color: #fff !important;
            background-color: #e04332 !important;
            border: 0 !important;
        }

        .new_r-item:hover .new_r-item-body {
            border-color: #e04332 #e04332 #e04332 transparent !important;
        }

        .new_r-item .new_r-item-price,
        .new_r-show-more-results {
            border-color: #e04332 !important;
        }

        .new_t-date-change-top,
        .new_t-date-change-bottom,
        .new_t-date-change-left,
        .new_t-date-change-right {
            background-color: #f7fafc !important;
        }

        .new_progressbar .new_progress-container,
        .food .new_t-modal-table .new_t-room-price:hover,
        .new_t-date_link.new_t-selected, .new_t-date_link:hover,
        .new_t-date-change-top:hover, .new_t-date-change-bottom:hover,
        .new_t-date-change-left:hover, .new_t-date-change-right:hover {
            background-color: #edf2f7 !important;
        }

        .food .new_t-modal-table .new_t-room-price.selected:hover *,
        .food .new_t-modal-table .new_t-room-price a,
        .new_serv-cols .new_h6,
        .new_r-filter-label,
        .new_r-item-geo,
        .new_r-item-info,
        .new_r-item-from,
        .new_r-item-date,
        .new_f-ext-bl label,
        .new_progressbar-text,
        .new_progressbar-text span {
            color: #4a5568 !important;
        }
        `;

        const styleTag = document.createElement('style');
        styleTag.textContent = customStyles;
        document.head.appendChild(styleTag);

        const scripts = [
            'https://api.otpusk.com/api/2.4/session?access_token=3ab2e-886a1-60f78-3392b-542a6',
            'https://export.otpusk.com/js/onsite/',
            'https://export.otpusk.com/js/order',
        ];

        const loadAll = async () => {
            for (const src of scripts) {
                await loadScript(src);
            }
        };
        loadAll().catch(err => console.error('Error int widget:', err));
    }, []);

    return <div className="search-tour-container">
        {/* <Iframe 
                className="iframe-search-tour-preview" 
                scrolling={windowWidth >= 1280 ? 'no' : 'yes'} 
                src="/1f5d0d747d04e1438abf0d5ee3ecafaf454a0050a602f0193d2ba1d7112752a0" 
            />; */}
    </div>;
}

SearchWidget.defaultProps = {
    windowWidth: 0,
};

export default SearchWidget;
